// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3_jn5","search":"Settings_search__3jRua","filter":"Settings_filter__335xE"};